import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  toggle() {
    const targetElement = document.querySelector(`[data-toggle-visibility-target="${this.targetValue}"]`)
    if (targetElement) {
      const isChecked = this.element.checked
      targetElement.style.display = isChecked ? '' : 'none'
    }
  }
}